import { errorPlayerContainerNotCreated } from './errors';
export const playerPause = async (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    await player.pause();
};
